import { useEffect, useState } from "react";
import { FaBoxOpen, FaUser, FaSignOutAlt } from "react-icons/fa";
import ShopNav from "../../../components/shopNav/ShopNav";
import NavCategorias from "../../../components/navbar/NavCategorias";
import Footer from "../../../components/footer/footer";
import { useNavigate } from "react-router-dom"; // <- agrega esto

const API_URL = import.meta.env.VITE_API_URL;

const HistorialPedidos = ({ user: userProp }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(userProp || null);
    const [pedidos, setPedidos] = useState([]);
    const [selectedPedido, setSelectedPedido] = useState(null);
    const [showPedidoModal, setShowPedidoModal] = useState(false);

    // Paginación
    const [currentPage, setCurrentPage] = useState(1);
    const pedidosPerPage = 5;

    const formatCurrency = (value) =>
        Number(value).toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
            minimumFractionDigits: 0,
        });

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/";
    };

    const handleShowModal = (pedido) => {
        setSelectedPedido(pedido);
        setShowPedidoModal(true);
    };

    const renderProgresoEnvio = (estadoActual) => {
        const etapas = [
            { nombre: "Recibido", clave: "recibido" },
            { nombre: "En tránsito", clave: "en_transito" },
            { nombre: "En aduanas", clave: "en_aduanas" },
            { nombre: "Entregado", clave: "entregado" },
            { nombre: "Finalizado", clave: "finalizado" },
        ];
        const idxActual = etapas.findIndex((e) => e.clave === estadoActual);
        return (
            <div className="d-flex gap-1 flex-wrap" style={{ fontSize: "0.75rem" }}>
                {etapas.map((etapa, i) => {
                    const color =
                        i < idxActual ? "success" : i === idxActual ? "warning" : "secondary";
                    return (
                        <span
                            key={etapa.clave}
                            className={`badge bg-${color} px-2 py-1 text-capitalize`}
                        >
                            {etapa.nombre}
                        </span>
                    );
                })}
            </div>
        );
    };

    useEffect(() => {
        if (!user) {
            const storedUser = localStorage.getItem("user");
            if (storedUser) setUser(JSON.parse(storedUser));
        }
    }, [user]);

    useEffect(() => {
        if (!user) return;
        fetch(`${API_URL}/checkout/pedidos?userId=${user.id}`)
            .then((res) => res.json())
            .then((data) => setPedidos(data.sort((a, b) => b.id - a.id)))
            .catch((err) => console.error("Error al obtener pedidos:", err));
    }, [user]);

    if (!user) return <p className="text-center py-5">Cargando...</p>;

    // Paginación
    const indexOfLast = currentPage * pedidosPerPage;
    const indexOfFirst = indexOfLast - pedidosPerPage;
    const currentPedidos = pedidos.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(pedidos.length / pedidosPerPage);

    const getPageNumbers = (totalPages, currentPage, delta = 2) => {
        const pages = [];
        const left = Math.max(2, currentPage - delta);
        const right = Math.min(totalPages - 1, currentPage + delta);

        pages.push(1);
        if (left > 2) pages.push("...");
        for (let i = left; i <= right; i++) pages.push(i);
        if (right < totalPages - 1) pages.push("...");
        if (totalPages > 1) pages.push(totalPages);
        return pages;
    };

    const getBorderByEnvio = (estado_envio) => {
        const colors = {
            recibido: "secondary",
            en_transito: "primary",
            en_aduanas: "warning",
            entregado: "success",
            finalizado: "dark",
        };
        return colors[estado_envio] || "secondary";
    };

    // Nuevo: background según pago
    const getBackgroundByPago = (pago) => {
        return pago ? "bg-success bg-opacity-10" : "bg-danger bg-opacity-10";
    };

    return (
        <>
            <ShopNav />
            <NavCategorias />
            <br />

            <main className="container py-4">
                <div className="row g-3">
                    {/* Sidebar Usuario */}
                    <div className="col-md-4">
                        <div className="card shadow-sm p-3 text-center ">
                            <FaUser size={50} className="mb-2 text-primary" />
                            <h6>{user.name || "Usuario"}</h6>
                            <p className="text-muted small">{user.email}</p>
                            {/* <button
                                className="btn btn-danger btn-sm w-100 mt-2"
                                onClick={handleLogout}
                            >
                                <FaSignOutAlt className="me-1" /> Cerrar sesión
                            </button> */}
                        </div>
                        <button
                            className="btn btn-secondary btn-sm w-100 mb-2"
                            onClick={() => navigate("/mi-cuenta")}
                        >
                            Volver a Mi Cuenta
                        </button>
                    </div>



                    {/* Historial de Pedidos */}
                    <div className="col-md-8">
                        {pedidos.length === 0 ? (
                            <div className="alert alert-info p-2">No tienes pedidos aún.</div>
                        ) : (
                            <>
                                <div className="list-group mb-2">
                                    {currentPedidos.map((pedido, i) => (
                                        <div
                                            key={i}
                                            className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center flex-wrap shadow-sm mb-2 border-start border-4 border-${getBorderByEnvio(
                                                pedido.estado_envio
                                            )} ${getBackgroundByPago(pedido.pago)}`}
                                            style={{ padding: "0.5rem 1rem" }}
                                        >
                                            <div className="d-flex flex-column flex-sm-row flex-fill gap-2 align-items-start align-items-sm-center">
                                                <div>
                                                    <strong>Orden:</strong> #{pedido.numero_orden}
                                                </div>
                                                <div>
                                                    <strong>Total:</strong> {formatCurrency(pedido.total)}
                                                </div>
                                                <div>
                                                    <strong>Pago:</strong>{" "}
                                                    <span
                                                        className={`badge ${pedido.pago ? "bg-success" : "bg-danger"
                                                            }`}
                                                    >
                                                        {pedido.pago ? "Pagado" : "Pendiente"}
                                                    </span>
                                                </div>
                                                <div>
                                                    <strong>Estado:</strong> {pedido.estado}
                                                </div>
                                                <div>{renderProgresoEnvio(pedido.estado_envio)}</div>
                                            </div>
                                            <button
                                                className="btn btn-sm btn-warning mt-1 mt-sm-0"
                                                onClick={() => handleShowModal(pedido)}
                                            >
                                                Ver detalles
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                {/* Paginación */}
                                <nav>
                                    <ul className="pagination justify-content-center mb-0">
                                        <li
                                            className={`page-item ${currentPage === 1 ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link bg-dark text-white py-2"
                                                onClick={() =>
                                                    setCurrentPage((p) => Math.max(p - 1, 1))
                                                }
                                            >
                                                Anterior
                                            </button>
                                        </li>

                                        {getPageNumbers(totalPages, currentPage).map((p, idx) =>
                                            p === "..." ? (
                                                <li key={idx} className="page-item disabled bg-dark text-white">
                                                    <span className="page-link bg-dark text-white">…</span>
                                                </li>
                                            ) : (
                                                <li
                                                    key={idx}
                                                    className={`page-item bg-dark text-white ${currentPage === p ? "active" : ""
                                                        }`}
                                                >
                                                    <button
                                                        className="page-link bg-dark text-white"
                                                        onClick={() => setCurrentPage(p)}
                                                    >
                                                        {p}
                                                    </button>
                                                </li>
                                            )
                                        )}

                                        <li
                                            className={`page-item  ${currentPage === totalPages ? "disabled" : ""
                                                }`}
                                        >
                                            <button
                                                className="page-link bg-dark text-white"
                                                onClick={() =>
                                                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                                                }
                                            >
                                                Siguiente
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                                <hr />
                            </>
                        )}
                    </div>
                </div>
            </main>

            {/* Modal de detalles */}
            {showPedidoModal && selectedPedido && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header bg-warning text-dark">
                                <h5 className="modal-title">Detalles del pedido</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowPedidoModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    <strong>Orden:</strong> #{selectedPedido.numero_orden}
                                </p>
                                <p>
                                    <strong>Total:</strong> {formatCurrency(selectedPedido.total)}
                                </p>
                                <p>
                                    <strong>Estado:</strong> {selectedPedido.estado}
                                </p>
                                {renderProgresoEnvio(selectedPedido.estado_envio)}
                                <hr />
                                <h6>Ítems:</h6>
                                <div className="table-responsive">
                                    <table className="table table-sm table-bordered">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Descripción</th>
                                                <th>Cant.</th>
                                                <th>Precio unit.</th>
                                                <th>Marca</th>
                                                <th>Categoría</th>
                                                <th>Peso</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedPedido.items.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.nombre}</td>
                                                    <td>{item.descripcion}</td>
                                                    <td>{item.cantidad}</td>
                                                    <td>{formatCurrency(item.precio_unitario)}</td>
                                                    <td>{item.marca}</td>
                                                    <td>{item.categoria}</td>
                                                    <td>{item.peso} kg</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-warning"
                                    onClick={() => setShowPedidoModal(false)}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
};

export default HistorialPedidos;
